import { Component, Input } from '@angular/core';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';

import { KPI } from '../../../@core/api';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@Component({
    selector: 'app-insight-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    standalone: true,
    imports: [
    RouterLinkActive,
    RouterLink,
    FontAwesomeModule,
    TranslateModule
],
})
export class BreadcrumbsComponent {

  @Input() public superCategory: KPI.SuperCategory;
  @Input() public showCategories: boolean;
  @Input() public category: KPI.Category;
  @Input() public subCategory: KPI.SubCategory;
  @Input() public assetType: KPI.AssetType;
  @Input() public asset: KPI.Asset;
  @Input() public investment: KPI.Investment;
  @Input() public roadmapIndicator: KPI.RoadmapIndicator;
  @Input() public chapter: KPI.Chapter;
  @Input() public perimeter: KPI.Perimeter;
  @Input() public nbSites: number;
  @Input() public site: KPI.Perimeter;
  @Input() public showSuperCategories: boolean;

  constructor(public router: Router) { }
}
